import type { InjectionKey, Ref } from 'vue';

/**
 * The id of a rule row whose column list should open as soon as the row mounts. Option+Enter
 * in the filter builder adds a row and sets this. The row clears it once it has opened its
 * column list, so the list opens once and never again when the row re-renders.
 */
export const OPEN_RULE_COLUMN_KEY: InjectionKey<Ref<string | null>> = Symbol('openRuleColumn');
